/*
 * After a deploy, a tab still running the previous version asks for code
 * chunks that no longer exist (their file names are content hashes). Reloading
 * once picks up the new version. The guard stops a reload loop if the chunk is
 * genuinely missing.
 */

const KEY = 'atlas-control.stale-build-reload';

export function isStaleBuildError(error: unknown): boolean {
  const message = error instanceof Error ? error.message : String(error);
  return /Failed to fetch dynamically imported module|Importing a module script failed|error loading dynamically imported module/i.test(
    message,
  );
}

/** Reloads the page unless it already did so in the last minute. Returns whether it reloads. */
export function reloadForNewVersion(): boolean {
  try {
    const last = Number(sessionStorage.getItem(KEY) ?? 0);
    if (Date.now() - last < 60_000) return false;
    sessionStorage.setItem(KEY, String(Date.now()));
  } catch {
    // Storage unavailable: reload anyway; the browser cannot loop faster than a page load.
  }
  window.location.reload();
  return true;
}

export function installStaleBuildHandler(): void {
  // Vite's own signal for a failed dynamic import.
  window.addEventListener('vite:preloadError', (event) => {
    if (reloadForNewVersion()) event.preventDefault();
  });
}
